import React, { Component } from "react";
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  Linking,
  ImageBackground,
} from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";
import { StackActions, NavigationActions } from "react-navigation";
import { EventRegister } from "react-native-event-listeners";
import moment from "moment";
import { format } from "date-fns";

import { getAluno, excluirConta } from "../../services/aluno-service";
import styles from "./styles";
import { formatDate, mascaraCpf } from "../../utils/formatUtils";
import { onSignOut } from "../../services/auth-service";
import { alert } from "../../utils/alerts";

class Perfil extends Component {
  static navigationOptions = ({ navigation }) => {
    return {
      headerStyle: {
        backgroundColor: "#0F0F0F",
      },
      headerTitleStyle: {
        color: "#F1F1F1",
      },
      headerLeft: () => (
        <TouchableOpacity
          onPress={() => {
            navigation.openDrawer();
          }}
        >
          <Icon
            style={styles.iconHeaderLeft}
            name="reorder"
            size={30}
            color="#F1F1F1"
          />
        </TouchableOpacity>
      ),
    };
  };

  constructor(props) {
    super();
    this.state = {
      aluno: {},
    };
  }

  loadData = async (refresh) => {
    // const alunoLocal = await getAlunoLocal()
    // if (refresh) {
    //   const response = await getAlunoApi(alunoLocal.cpf)
    //   if (response.ok) {
    //     const aluno = await response.json()
    //     this.setState({ aluno })
    //   }
    // }else{
    //   this.setState({aluno: alunoLocal})
    // }
  };

  componentDidMount = async () => {
    this.listener = EventRegister.addEventListener(
      "reloadPerfil",
      async (data) => {
        this.setState({ aluno: await getAluno(true) });
      }
    );
    this.setState({ aluno: await getAluno(false) });
  };

  navigateToEditarEndereco = () => {
    this.props.navigation.navigate("EditarEndereco", {
      aluno: this.state.aluno,
    });
  };

  navigateToEditarProfissionais = () => {
    this.props.navigation.navigate("EditarDadosProfissionais", {
      aluno: this.state.aluno,
    });
  };

  navigateToEditarEmail = () => {
    this.props.navigation.navigate("EditarEmail", {
      aluno: this.state.aluno,
    });
  };

  componentWillUnmount = () => {
    EventRegister.removeEventListener(this.listener);
  };

  handleLinkCurricullo = async () => {
    const supported = await Linking.canOpenURL(this.state.aluno.link_curriculo);

    if (supported) {
      // Opening the link with some app, if the URL scheme is "http" the web link should be opened
      // by some browser in the mobile
      await Linking.openURL(this.state.aluno.link_curriculo);
    } else {
      alert(`Não podemos abrir esse link`);
    }
  };

  handleExcluirConta = () => {
    alert(
      "Confirmar exclusão dos dados",
      "Confirma que deseja excluir seus dados do aplicativo e parar de receber oportunidades do Senai?",
      [
        {
          text: "Cancelar",
          style: "cancel",
        },
        {
          text: "SIM",
          onPress: async () => {
            try {
              const response = await excluirConta();
              if (!response.ok) {
                let { erro } = await response.json();
                setLoading(false);
                return alert("Ops...", erro);
              }

              onSignOut();
              const navigateAction = StackActions.reset({
                index: 0,
                actions: [
                  NavigationActions.navigate({ routeName: "SignedOut" }),
                ],
              });
              this.props.navigation.dispatch(navigateAction);
            } catch (erro) {
              console.log(erro);
              alert(
                "Ops...",
                "Houve um problema ao consultar, verifique o numero e tente novamente"
              );
            }
          },
        },
      ]
    );
  };

  render() {
    const { aluno } = this.state;

    return (
      <ImageBackground
        source={require("../../../resources/imgs/bg.jpg")}
        style={[styles.container]}
        imageStyle={styles.imageContainer}
      >
        <ScrollView
          style={{ height: 100 }}
          showsVerticalScrollIndicator={false}
        >
          <View style={styles.personalData}>
            <View style={styles.header}>
              <Text style={styles.textHeader}>Dados pessoais</Text>
            </View>
            <View style={styles.body}>
              <Text style={[styles.dataProperty, { marginTop: 0 }]}>NOME:</Text>
              <Text style={styles.dataValue}>{aluno.nome}</Text>

              <Text style={[styles.dataProperty, { marginTop: 0 }]}>CPF:</Text>
              <Text style={styles.dataValue}>{mascaraCpf(aluno.cpf)}</Text>

              <Text style={[styles.dataProperty, { marginTop: 0 }]}>
                DATA DE NASCIMENTO:
              </Text>
              <Text style={styles.dataValue}>
                {aluno.data_nasc && formatDate(aluno.data_nasc)}
              </Text>

              <Text style={[styles.dataProperty, { marginTop: 0 }]}>SEXO:</Text>
              <Text style={styles.dataValue}>
                {aluno.sexo === "M" ? "Masculino" : "Feminino"}
              </Text>
              <TouchableOpacity style={{}} onPress={this.navigateToEditarEmail}>
                <Text style={[styles.dataProperty, { marginTop: 0 }]}>
                  E-MAIL:
                </Text>
                <View style={{ flexDirection: "row" }}>
                  <Text style={styles.dataValue}>{aluno.email}</Text>
                  <Icon
                    style={{ paddingLeft: 10 }}
                    name="edit"
                    size={20}
                    color="#C1C1C1"
                  />
                </View>
              </TouchableOpacity>

              <Text style={styles.alert}>
                Encontrou algo de errado aqui? Atualize seus dados na secretaria
                da sua escola.
              </Text>
            </View>
          </View>

          <View style={styles.personalData}>
            <View style={styles.header}>
              <Text style={styles.textHeader}>Dados Profissionais</Text>
              <TouchableOpacity
                style={styles.iconEdit}
                onPress={this.navigateToEditarProfissionais}
              >
                <Icon name="edit" size={20} color="white" />
              </TouchableOpacity>
            </View>

            <View style={styles.body}>
              <Text style={[styles.dataProperty, { marginTop: 0 }]}>
                ESTÁ TRABALHANDO ATUALMENTE:
              </Text>
              <Text style={styles.dataValue}>
                {aluno.trabalhando ? "Sim" : "Não"}
              </Text>
              <Text style={[styles.dataProperty, { marginTop: 0 }]}>
                PROCURANDO NOVAS OPORTUNIDADES:
              </Text>
              <Text style={styles.dataValue}>
                {aluno.procurando_trabalho ? "Sim" : "Não"}
              </Text>

              <Text style={[styles.dataProperty, { marginTop: 0 }]}>
                LINK CURRÍCULO:
              </Text>
              <TouchableOpacity onPress={this.handleLinkCurricullo}>
                <Text style={styles.dataValue}>
                  {aluno.link_curriculo ? "Abrir link ->" : "Não"}
                </Text>
              </TouchableOpacity>
            </View>
          </View>

          <View style={[styles.personalData]}>
            <View style={styles.header}>
              <Text style={styles.textHeader}>Endereço</Text>
              <TouchableOpacity
                style={styles.iconEdit}
                onPress={this.navigateToEditarEndereco}
              >
                <Icon name="edit" size={20} color="white" />
              </TouchableOpacity>
            </View>
            <View style={styles.body}>
              {/* <Text style={[styles.dataProperty, { marginTop: 0 }]}>
              LOGRADOURO:
            </Text>
            <Text style={styles.dataValue}>{aluno.endereco}</Text> */}

              <Text style={[styles.dataProperty, { marginTop: 0 }]}>
                BAIRRO:
              </Text>
              <Text style={styles.dataValue}>{aluno.bairro}</Text>

              <Text style={[styles.dataProperty, { marginTop: 0 }]}>
                MUNICIPIO:
              </Text>
              <Text style={styles.dataValue}>{aluno.municipio}</Text>

              <Text style={[styles.dataProperty, { marginTop: 0 }]}>
                ESTADO:
              </Text>
              <Text style={styles.dataValue}>{aluno.estado}</Text>

              <Text style={[styles.dataProperty, { marginTop: 0 }]}>CEP:</Text>
              <Text style={[styles.dataValue, { marginBottom: 0 }]}>
                {aluno.cep}
              </Text>
            </View>
          </View>
          <TouchableOpacity
            style={[
              styles.botao,
              { backgroundColor: "#000077", marginBottom: 0 },
            ]}
            onPress={() => this.props.navigation.navigate("AlterarSenha")}
          >
            <Text style={styles.botaoText}>Alterar senha</Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.botao}
            onPress={this.handleExcluirConta}
          >
            <Text style={styles.botaoText}>Excluir conta</Text>
          </TouchableOpacity>
        </ScrollView>
      </ImageBackground>
    );
  }
}
export default Perfil;
